import { Component, inject, signal, viewChild } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { DiceColor, DiceService } from '../../services/dice-service.service';
import { TextsService } from '../../services/texts.service';
import { RidSfxDirective } from '../../directives/rid-sfx.directive';
import { AudioEffectPlayer } from '../../utils/audio.utils';
import { RidDiceSlot } from '../rid-dice-slot/rid-dice-slot';
import { RidDice } from '../rid-dice/rid-dice';
import { RidModalBackground } from '../rid-modal-background/rid-modal-background';

@Component({
  selector: 'rid-dice-overlay',
  imports: [RidModalBackground, RidDice, RidDiceSlot, RidSfxDirective],
  templateUrl: './rid-dice-overlay.html',
  host: {
    class: 'block pointer-events-none absolute inset-0 overflow-hidden',
  },
})
export class RidDiceOverlay {
  protected readonly $diceService = inject(DiceService);
  protected readonly $textsService = inject(TextsService);

  readonly centerDice = viewChild<RidDice>('centerDice');
  dice = signal<{ faces: string[] | undefined; color: DiceColor } | undefined>(undefined);
  readonly showReadingHint = signal(false);
  readonly numericDice = signal<number | undefined>(undefined);

  constructor() {
    this.$diceService.registerAnimationHandler((color, faces, result) => this.rollCenterDice(color, faces, result));
  }

  async toggleNumericDice() {
    if (this.numericDice()) {
      this.numericDice.set(undefined);
    } else {
      this.numericDice.set(await this.$diceService.roll('EMERALD'));
    }
  }

  private async rollCenterDice(color: DiceColor, faces: string[] | undefined, result: number): Promise<void> {
    this.dice.set({ faces, color });
    this.showReadingHint.set(false);

    await delay(500);

    const center = this.centerDice();

    if (!center) {
      throw new Error('Dice not initialized');
    }

    // Show and roll the center dice
    await center.roll(result);
    void AudioEffectPlayer.play('DICE_RESULT');
    this.showReadingHint.set(true);

    // Present the result (scale up)
    await center.present();
    await this.$textsService.tryPronounce('expression-dice.result-instruction');
    await delay(500);

    this.showReadingHint.set(false);
    this.dice.set(undefined); // hide center dice
  }
}
